import useMediaQuery from '@mui/material/useMediaQuery';
import { useLocalStorage } from 'react-use';

const useThemeToggle = () => {
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
  const [isDark, setValue] = useLocalStorage(
    'dispatch-theme-is-darkmode',
    prefersDarkMode
  );
  const toggle = () => setValue(!isDark);
  return {
    isDark: isDark ?? prefersDarkMode,
    toggle,
  };
};

export default useThemeToggle;
